export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-team-line',
      title: 'Experienced Professionals',
      description: 'Our team of trained movers has 20+ years of experience handling moves of all sizes with expert care and efficiency.',
      highlight: true,
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully licensed and insured for your peace of mind. Your belongings are protected throughout the entire moving process.',
      highlight: false,
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'No hidden fees or surprise charges. Get accurate, upfront quotes with detailed breakdowns of all costs.',
      highlight: false,
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Service',
      description: 'We respect your schedule. Punctual arrivals and efficient service to complete your move on time, every time.',
      highlight: true,
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Exceptional Customer Care',
      description: 'Family-owned business dedicated to customer satisfaction. We treat your belongings like our own.',
      highlight: false,
    },
    {
      icon: 'ri-tools-fill',
      title: 'Professional Equipment',
      description: 'Modern trucks, quality packing materials, and specialized equipment for safe, efficient moves.',
      highlight: false,
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header - Asymmetrical */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="inline-block bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              Why Choose Us
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
              Your Trusted Moving Partner in Southern California
            </h2>
            <p className="text-xl text-slate-600">
              We're not just movers – we're your neighbors, committed to making your relocation stress-free and seamless.
            </p>
          </div>
          <div className="bg-white rounded-3xl p-8 shadow-lg border-2 border-orange-100">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl flex items-center justify-center">
                <i className="ri-map-pin-user-line text-3xl text-white"></i>
              </div>
              <div>
                <div className="text-3xl font-bold text-slate-900">Local Experts</div>
                <div className="text-slate-600">Serving Your Community</div>
              </div>
            </div>
            <p className="text-slate-600 leading-relaxed">
              As a family-owned business based in Southern California, we understand the unique needs of our community. We're here to help our neighbors move with care and professionalism.
            </p>
          </div>
        </div>

        {/* Asymmetrical Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className={`group ${
                benefit.highlight 
                  ? 'bg-gradient-to-br from-orange-500 to-red-500 text-white' 
                  : 'bg-white border-2 border-gray-100 hover:border-orange-200'
              } rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${
                index === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${
                    benefit.highlight 
                      ? 'bg-white/20' 
                      : 'bg-orange-100 group-hover:bg-orange-200'
                  } transition-colors`}>
                    <i className={`${benefit.icon} text-3xl ${
                      benefit.highlight ? 'text-white' : 'text-orange-600'
                    }`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className={`text-xl font-bold mb-3 ${
                    benefit.highlight ? 'text-white' : 'text-slate-900'
                  }`}>
                    {benefit.title}
                  </h3>
                  <p className={`leading-relaxed ${
                    benefit.highlight ? 'text-white/90' : 'text-slate-600'
                  }`}>
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Signal Bar */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl p-6 shadow-md border border-orange-100 text-center">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-heart-line text-2xl text-orange-600"></i>
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2">Family Owned</div>
            <div className="text-slate-600 text-sm">Serving families since 2003</div>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-md border border-orange-100 text-center">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-community-line text-2xl text-orange-600"></i>
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2">Community Focused</div>
            <div className="text-slate-600 text-sm">Your neighbors you can trust</div>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-md border border-orange-100 text-center">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-hand-heart-line text-2xl text-orange-600"></i>
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2">Care & Respect</div>
            <div className="text-slate-600 text-sm">Treating your home like ours</div>
          </div>
        </div>
      </div>
    </section>
  );
}